import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Grid, Text, Anchor, Group, Stack } from '@mantine/core';

const Footer: React.FC = () => {
    return (
        <footer className="border-t border-gray-200 bg-white mt-auto">
            <Container size="lg" className="py-8">
                <Grid>
                    <Grid.Col span={{ base: 12, sm: 4 }}>
                        <Stack gap="xs">
                            <Text fw={600} size="lg" className="text-gray-800">
                                About
                            </Text>
                            <Text size="sm" className="text-gray-600">
                                Rwanda Health Council Connect (RHCC) provides certification and verification services
                                for healthcare professionals and organizations in Rwanda.
                            </Text>
                        </Stack>
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 4 }}>
                        <Stack gap="xs">
                            <Text fw={600} size="lg" className="text-gray-800">
                                Quick Links
                            </Text>
                            <Stack gap="xs">
                                <Anchor component={Link} to="/verify-certificate" className="text-gray-600 hover:text-gray-800">
                                    Verify Certificate
                                </Anchor>
                                <Anchor component={Link} to="/HomePage" className="text-gray-600 hover:text-gray-800">
                                    Create Account
                                </Anchor>
                                <Anchor component={Link} to="/auth/login" className="text-gray-600 hover:text-gray-800">
                                    Login
                                </Anchor>
                            </Stack>
                        </Stack>
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 4 }}>
                        <Stack gap="xs">
                            <Text fw={600} size="lg" className="text-gray-800">
                                Support
                            </Text>
                            <Stack gap="xs">
                                <Anchor component={Link} to="/profile" className="text-gray-600 hover:text-gray-800">
                                    My Profile
                                </Anchor>
                                <Anchor component={Link} to="/usercertificates" className="text-gray-600 hover:text-gray-800">
                                    My Certificates
                                </Anchor>
                                <Anchor component={Link} to="/userprofilesettings" className="text-gray-600 hover:text-gray-800">
                                    Settings
                                </Anchor>
                            </Stack>
                        </Stack>
                    </Grid.Col>
                </Grid>

            </Container>
            <Group justify="center" mt="xl" className='w-full border-t py-6'>
                <Text size="sm" className="text-gray-600">
                    © {new Date().getFullYear()} Rwanda Health Council Connect. All rights reserved.
                </Text>
            </Group>
        </footer>
    );
};

export default Footer; 